import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public triggerLoaderChange: BehaviorSubject<any> = new BehaviorSubject(null);
  private _isLoading: boolean = false;
  private _counter: number = 0;

  constructor() {
    this._isLoading = false;
    this._counter = 0;
  }

  

  public show() {
    this._counter++;
   
    if (!this._isLoading) {
      this._isLoading = true;
      this.triggerLoaderChange.next({ value: true });
      
    }
  }

  public hide() {
    this._counter--;
 
    if (this._counter <= 0) {
      this._counter = 0;
      if (this._isLoading) {
        this._isLoading = false;
        this.triggerLoaderChange.next({ value: false });
      }
      
    }
  }

}
